
import { http } from '@/plugins/axios';

const API_ROOT = 'https://api.sm-center.ru';

export const getRequestPaymentInfo = (token: string) => {
  return http.get(`/RequestPayment/${token}/Info`, {
    baseURL: API_ROOT,
  });
};

export const getPayLink = (token: string) => {
  return http.get(`/RequestPayment/${token}/GetPayLink`, {
    baseURL: API_ROOT,
  });
};

export const getSbpPayLink = (token: string) => {
  return http.get(`/RequestPayment/${token}/GetSbpPayLink`, {
    baseURL: API_ROOT,
  });
};

export const getContractHtml = (token: string) => {
  return http.get(`/RequestPayment/${token}/GetContractHtml`, {
    baseURL: API_ROOT,
  });
};

export const confirmContract = (token: string) => {
  return http.get(`/RequestPayment/${token}/ConfirmContract`, {
    baseURL: API_ROOT,
  });
};